import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'kh-input',
  styleUrls: ['./input.component.less'],
  templateUrl: './input.component.html',
  standalone: false
})
export class InputComponent implements OnInit {
  @Input() public controlValue: AbstractControl;
  @Input() public controlType = 'text';
  @Input() public placeholder = '';

  public hasValidation = false;

  public ngOnInit(): void {
    this.hasValidation = !!this.controlValue.validator;
  }
}
